import { DEBUG } from '../../../config';

const counters: Record<string, number> = {};

export function noteFullReplaceFallback(reason: string): void {
  counters[reason] = (counters[reason] ?? 0) + 1;
  // eslint-disable-next-line no-console
  if (DEBUG) console.debug(`[tgim-ux-perf] full replace fallback: ${reason}`, counters[reason]);
}

export function getUxPerfCounterSnapshot(): Record<string, number> {
  return { ...counters };
}
